import { observable, action } from 'mobx';
import {RModel} from "../models/RModel";
import {IRecipientRecord} from "platform_common/types/data/RecipientRecord";

/**
 * Store for Recipient related state.
 */
export class RStore {

    @observable
    public r: RModel;

    /**
     * R store is an instance of the R model.
     *
     * @param {RModel} p
     */
    constructor(p: RModel) {
        this.r = p;
    }

    /**
     * Set current recipient record.
     *
     * @param recipientRecord
     */
    @action
    public setRecipientRecord(recipientRecord:IRecipientRecord):void
    {
        this.r.recipientRecord = recipientRecord;
    }
}

export default RStore;